import { Box } from "@material-ui/core";
import { formatTimestamp } from "swyft-react-core";

import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

const QuoteDetailsHeader = ({ quote, quoteName }: Props) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  if (quote === null) {
    return null;
  }

  return (
    <Box display={"flex"} width={"100%"} marginBottom={isMoreThanMd ? "30px" : "11px"} justifyContent={"space-between"}>
      {isMoreThanMd && (
        <Box paddingLeft={"40px"} fontSize={"20px"} fontWeight={600} color="#1e073f">
          Quote Breakdown
        </Box>
      )}
      <Box width={isMoreThanMd ? "auto" : "100%"}>
        <Box
          display={isMoreThanMd ? "flex" : "block"}
          fontSize={isMoreThanSm ? "14px" : "12px"}
          fontWeight={400}
          width={"100%"}
          color="#4b5462"
          padding={isMoreThanMd ? 0 : "26px 24px 19px 33px"}
        >
          <Box
            display="flex"
            marginRight={"66px"}
            width={isMoreThanMd ? "auto" : "100%"}
            justifyContent={"space-between"}
            mb={isMoreThanMd ? 0 : "15px"}
          >
            <Box>Ref No:</Box>
            <Box ml={1}>{quoteName}</Box>
          </Box>
          <Box display="flex" mr={2.6} width={isMoreThanMd ? "auto" : "100%"} justifyContent={"space-between"}>
            <Box>Valid until:</Box>
            <Box ml={1}>{formatTimestamp(quote.expiry || quote.created + 30 * 24 * 60 * 60 * 1000)}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuoteDetailsHeader;

interface Props {
  quoteName: string;
  quote: Quote | null;
}
